import React from 'react';
import {Outlet} from "react-router-dom";
import {AuthService} from "../../service/AuthService";
import {Forbidden} from "../../components/Forbidden";

export const Document = () => {
  return (
    <>
      { !AuthService.hasRole('ROLE_BUREAU') && (
        <Forbidden module="document"/>
      )}
      { AuthService.hasRole('ROLE_BUREAU') && (
        <Outlet/>
      )}
    </>
  );
}
